module.exports = __webpack_public_path__ + "static/media/android_tips_04.107cd795.png";